// extracted by mini-css-extract-plugin
export var option = "_bc-0";
export var optionCard = "_bc-f";
export var optionContent = "_bc-g";
export var optionIcon = "_bc-i";
export var optionIconBox = "_bc-h";
export var optionLabel = "_bc-j";
export var optionPill = "_bc-m";
export var optionPillBadge = "_bc-p";
export var optionPillIcon = "_bc-n";
export var optionPillLabel = "_bc-o";
export var optionRadio = "_bc-k";
export var optionRadioInner = "_bc-l";
export var optionReveal = "_bc-2";
export var optionRevealDelay0 = "_bc-3";
export var optionRevealDelay1 = "_bc-4";
export var optionRevealDelay10 = "_bc-d";
export var optionRevealDelay11 = "_bc-e";
export var optionRevealDelay2 = "_bc-5";
export var optionRevealDelay3 = "_bc-6";
export var optionRevealDelay4 = "_bc-7";
export var optionRevealDelay5 = "_bc-8";
export var optionRevealDelay6 = "_bc-9";
export var optionRevealDelay7 = "_bc-a";
export var optionRevealDelay8 = "_bc-b";
export var optionRevealDelay9 = "_bc-c";
export var optionSelected = "_bc-1";